//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Portal from "@material-ui/core/Portal";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import ManageLoaderUsersTable from "../table/ManageLoaderUsersTable";
import CloseableDialog from "eai-configurator-ui/components/configuration/dialog/CloseableDialog";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Utils from "eai-configurator-ui/components/Utils";
import * as SessionInfo from "eai-configurator-ui/components/SessionInfo";
import {useSessionInfo} from "eai-configurator-ui/components/SessionInfo";

const ManageLoaderUsersDialog = ({open, handleClose, layoutToolEnabled, automationEnabled}) => {
  const [sessionInfo] = useSessionInfo();
  const [alertMessage, setAlertMessage] = React.useState(null);
  const [users, setUsers] = React.useState([]);

  const userLicensed = sessionInfo && sessionInfo.props && sessionInfo.props.licensed;

  // Additional intelligence to decide if this dialog should be visible or not
  const showManageUsersDialog = sessionInfo && sessionInfo.props && sessionInfo.props.showManageUsersDialog
  let forceDialogOpen = sessionInfo && showManageUsersDialog

  const dialogOpen = open || forceDialogOpen;

  React.useEffect(() => {
    if (dialogOpen) {
      populateTable();
    } else {
      setAlertMessage(null);
    }
  }, [dialogOpen]);

  const onClose = () => {
    if (userLicensed) {
      handleClose();
    } else {
      // Logout
      SessionInfo.clear();
    }
  };

  const populateTable = () => {
    let url = "loader/readLoaderUsers";
    Utils.fetchData(url)
      .then((users) => {
        setUsers(users);
      })
      .catch(function (response) {
        setUsers([]);
        Utils.getErrorMessage(response, "Failed to fetch users.").then(
          (message) =>
            setAlertMessage({
              success: false,
              message: message,
            })
        );
      });
  };

  const saveUsers = () => {
    let url = "loader/saveLoaderUsers";
    Utils.fetchData(
      url,
      {
        method: "post",
        body: JSON.stringify({
          list: users,
        }),
      },
      true,
      false
    )
      .then((response) => {
        setAlertMessage({
          success: true,
          message: "Saved successfully.",
        });

        // Refresh session to check whether user has become (un)licensed
        SessionInfo.refresh();
      })
      .catch(function (response) {
        Utils.getErrorMessage(response, "Failed to save users.").then(
          (message) =>
            setAlertMessage({
              success: false,
              message: message,
            })
        );
      });
  };

  if (!sessionInfo) {
    return null;
  }
  return (
    <span>
      {alertMessage && (
        <Portal>
          <Snackbar
            open={alertMessage}
            autoHideDuration={6000}
            onClose={() => setAlertMessage(null)}
          >
            <Alert
              onClose={() => setAlertMessage(null)}
              severity={
                alertMessage && alertMessage.success ? "success" : "error"
              }
            >
              {alertMessage && (alertMessage.message || "Unknown error")}
            </Alert>
          </Snackbar>
        </Portal>
      )}
      <CloseableDialog
        dividers
        open={dialogOpen}
        title={"Manage Users"}
        maxWidth="lg"
        handleClose={onClose}
        closeIcon={userLicensed ? <CloseIcon/> : <LogoutIcon/>}
      >
        <DialogContent dividers>
          {users ? (
            <ManageLoaderUsersTable
              users={users}
              setUsers={setUsers}
              layoutToolEnabled={layoutToolEnabled}
              automationEnabled={automationEnabled}
            />
          ) : (
            <CircularProgress
              color="inherit"
              style={{marginLeft: "10px"}}
              size={20}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={saveUsers}>
            Save
          </Button>
        </DialogActions>
      </CloseableDialog>
    </span>
  );
};
export default ManageLoaderUsersDialog;
